import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-950 border-t border-background-800">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-fill text-primary-500 text-2xl"></i>
              </div>
              <span className="text-lg font-heading font-bold text-foreground-100">
                七七影院
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              七七影院提供海量高清免费电影与免费电视剧在线观看服务。画质超清不缓冲，无需付费即点即看，每日更新最新资源。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-300 mb-4">
              快速导航
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                  全部影视
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-300 mb-4">
              热门分类
            </h4>
            <ul className="flex flex-col gap-2">
              {categories.slice(1, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-300 mb-4">
              更多分类
            </h4>
            <ul className="flex flex-col gap-2">
              {categories.slice(6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} 七七影院 版权所有 | 高清免费电影 · 免费电视剧在线看
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-600 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-600 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">
              服务条款
            </a>
            <a href="#" className="text-xs text-foreground-600 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}